<script >
const __sfc_main = {};
export default __sfc_main;
</script>
<template>
    <div class="fixed-box__close-btn" v-on="$listeners">
    </div>
</template>
<style lang="less" scoped>
.fixed-box__close-btn {
    // 图片较小 base64处理
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA9klEQVQ4jZXTy00DMRAA0BeLCiDbBb+0gJIWQKIIDikDCVrILaKHhZQACW1AUgOHjJXF2k/ik+UZPc+M5dFisZjgGQ/YOW1VeMNTwiumeMf5icgKd3hJuMc3JoFdnIBc4hOPCT9RUcbqAaxEZtilCB6LtSKQGkklVrbZiZRQid0GNh5C4Kyl/IzVgdWR14l0QRmbNTD46kLaWuuLj/ryuwIVPnAVlWwc2hwfC1X2Q87I1L6ljOUH6IUycu3/TPIDbHDThqUBZNuI/7ZgVQkNISW2DqzOWIpNHci6B2lisxJLWMbBOm7rQ7oqWybMQz0WyWvr8APmf+ZSWBeER3GnAAAAAElFTkSuQmCC);
    position: absolute;
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
}
</style>
